import React from 'react';
import { createStyles, Grid, makeStyles, Typography } from '@material-ui/core';
import {
  AutoPxPriceLabel,
  colors,
  HeadlineText,
  moneyFormat,
  CrossOut,
} from 'design-system';
import { Quotation } from 'data-layer-cr/dist/models';
import getMonthlyPrice from 'src/functions/getMonthlyPrice';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      textAlign: 'center',
    },
    dashedLine: {
      borderTop: `1px dashed ${colors.silver}`,
      marginRight: 12,
      marginLeft: 12,
      border: 'none',
      width: '100%',
      marginTop: 0,
      marginBottom: 0,
    },
    captionPrice: {
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '21px',
      textAlign: 'center',
    },
  }),
);

const { formatMoney } = moneyFormat;

type Props = {
  optionTitle?: string;
  isAutoPx: boolean;
  totalPrice: number;
  paymentQuantity: number;
  regularPrice?: number;
  quotation: Quotation;
};

const QuotationPriceHeader = ({
  optionTitle,
  isAutoPx,
  totalPrice,
  paymentQuantity,
  regularPrice,
  quotation,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid
      container
      justifyContent="center"
      spacing={2}
      className={classes.container}
    >
      {optionTitle && (
        <Grid item xs={12}>
          <Typography data-testid="option-title">{optionTitle}</Typography>
        </Grid>
      )}
      {isAutoPx && (
        <Grid item xs={12} data-testid="auto-px-label">
          <AutoPxPriceLabel variant="withAutoPx" />
        </Grid>
      )}
      <Grid item xs={12} container direction="row">
        <Grid item xs={6} container direction="column">
          <Grid item data-testid="quota-value">
            <HeadlineText>
              {formatMoney(
                getMonthlyPrice(totalPrice),
                true,
                quotation.quotationProfile.typeOfMoney,
              )}
            </HeadlineText>
          </Grid>
          <Typography variant="caption" data-testid="number-quote">
            <CrossOut
              numberToCrossOut={paymentQuantity}
              maxQuote={paymentQuantity}
            />{' '}
            cuotas mensuales
          </Typography>
        </Grid>
        <Grid item xs={6} container direction="column">
          <Grid item data-testid="total-anual">
            <HeadlineText>
              {formatMoney(
                totalPrice,
                true,
                quotation.quotationProfile.typeOfMoney,
              )}
            </HeadlineText>
          </Grid>
          <Typography data-testid="description-anual" variant="caption">
            Total anual
          </Typography>
        </Grid>
      </Grid>
      {isAutoPx && (
        <>
          {/** Dashed Line */}
          <hr className={classes.dashedLine} />
          <Grid item xs={12}>
            <Typography
              className={classes.captionPrice}
              data-testid="without-autopx-label"
            >
              <AutoPxPriceLabel
                variant="withoutAutoPx"
                basePrice={regularPrice}
              />
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default QuotationPriceHeader;
